import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgHouse5 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke='#fff'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='m2 10 10-6 10 6'
    />
    <path
      fill='#fff'
      d='M19 18V9.332a2 2 0 0 0-.971-1.715L12 4 5.971 7.617A2 2 0 0 0 5 9.332V18a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgHouse5)
export default ForwardRef
